module.exports = __webpack_public_path__ + "img/bullet_02_fast_paced.72bf1550.png";